import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-userprofile-grid',
  templateUrl: './userprofile-grid.component.html',
  styleUrls: ['./userprofile-grid.component.css']
})
export class UserprofileGridComponent implements OnInit {

  title = "View User Profile";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/master/userprofile/userprofile-grid/userprofile-grid.component.ts